import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Upload = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="upload icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M5.49603 10.388C5.07886 10.3896 4.68991 10.228 4.40055 9.93529L4.26268 9.7959C3.99084 9.52187 3.84 9.15534 3.84 8.77011C3.84 8.36747 4.00284 7.99016 4.29869 7.70663L11.024 1.30704C11.5116 0.841982 12.3021 0.84515 12.7865 1.31179L19.5656 7.84919C19.8566 8.12955 20.0172 8.50527 20.0172 8.90475C20.0172 9.28205 19.8712 9.64384 19.6059 9.91976C19.3204 10.2157 18.9331 10.3832 18.5153 10.3864C18.0981 10.3912 17.7078 10.2328 17.4149 9.94321L13.5306 6.07038V17.089C13.5306 17.9532 12.8134 18.6536 11.9284 18.6536C11.0438 18.6536 10.3266 17.9532 10.3266 17.089V6.10523L6.58956 9.93054C6.30182 10.2236 5.91287 10.3864 5.49603 10.388Z"
    />
    <path
      className={pathClass}
      d="M5.44646 20.1889H18.4534C19.3406 20.1889 20.0598 20.8271 20.0598 21.6146C20.0598 22.4018 19.3406 23.04 18.4534 23.04H5.44646C4.55918 23.04 3.84006 22.4018 3.84006 21.6146C3.84006 20.8271 4.55918 20.1889 5.44646 20.1889Z"
    />
  </svg>
)
